import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Ignore the browser's noisy ResizeObserver loop warnings without altering
// ResizeObserver behavior globally, which can interfere with Monaco.
const resizeObserverErrorPattern = /^ResizeObserver loop (limit exceeded|completed with undelivered notifications)\.?$/;

window.addEventListener('error', (event) => {
  if (resizeObserverErrorPattern.test(event.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason =
    typeof event.reason === 'string'
      ? event.reason
      : typeof event.reason?.message === 'string'
        ? event.reason.message
        : '';

  if (resizeObserverErrorPattern.test(reason)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
